export default __webpack_public_path__ + "static/media/material-ui_materialui.857ef277.svg";